import axios from "axios";

function getData(data) {
    return axios.post('api/contrato/dataTable', data);
}

function getInfoContrato(data) {
    return axios.post('api/contrato/getInfocontract', data);
}

function guardarContrato(data) {
    return axios.post('api/contrato/guardarContrato', data);
}

function getSelectResourceTarget(data) {
    return axios.post('api/contrato/getSelectResourceTarget', data);
}

function onMoveSource(data) {
    return axios.post('api/contrato/onMoveSource', data);
}


function onMoveTarget(data) {
    return axios.post('api/contrato/onMoveTarget', data);
}

function adicionarContrato(data) {
    return axios.put('api/contrato/adicionarContrato', data);
}

function editarContrato(data) {
    return axios.put('api/contrato/editarContrato', data);
}

function getSelect() {
    return axios.get('api/contrato/getSelect');
}


function consultarNodoArbol() {
    return axios.get('api/contrato/optenerNodosClientes');
}

function getClienteContratos() {
    return axios.get('api/contrato/getClienteContratos').then(r => r.data);
}

function eliminarContrato(id){
    return axios.delete(`api/contrato/${id}`).then(r => r.data);
}

export {
    getData,
    editarContrato,
    guardarContrato,
    getSelect,
    consultarNodoArbol,
    getInfoContrato,
    getClienteContratos,
    adicionarContrato,
    getSelectResourceTarget,
    onMoveSource,
    onMoveTarget,
    eliminarContrato
}
